// extracted by mini-css-extract-plugin
export default {"heading":"PageList_heading__At1te","no-lists-items":"PageList_no-lists-items__yzDQa","list":"PageList_list__m-nzh"};